import React from "react";
import PropTypes from "prop-types";
import { Checkbox, TextField } from "app/components/FormikField/base";
import { Field } from "formik";
import Typography from "@mui/material/Typography";
const FormikTextField = ({ name, label, fieldType, disableField = false }) => {
  if (fieldType === "checkbox")
    return /* @__PURE__ */ React.createElement(Typography, null, label, /* @__PURE__ */ React.createElement(
      Field,
      {
        color: "primary",
        type: fieldType,
        component: Checkbox,
        disabled: disableField,
        name,
        label,
        fullWidth: true
      }
    ));
  if (fieldType === "float")
    return /* @__PURE__ */ React.createElement(Typography, null, /* @__PURE__ */ React.createElement(
      Field,
      {
        color: "primary",
        type: "number",
        inputProps: { step: "0.1" },
        component: TextField,
        name,
        label,
        fullWidth: true,
        disabled: disableField
      }
    ));
  if (fieldType === "number")
    return /* @__PURE__ */ React.createElement(Typography, null, /* @__PURE__ */ React.createElement(
      Field,
      {
        color: "primary",
        type: "number",
        inputProps: { step: "1" },
        component: TextField,
        name,
        label,
        fullWidth: true,
        disabled: disableField
      }
    ));
  return /* @__PURE__ */ React.createElement(
    Field,
    {
      color: "secondary",
      type: fieldType,
      disabled: disableField,
      component: TextField,
      name,
      label,
      fullWidth: true
    }
  );
};
FormikTextField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.any.isRequired,
  fieldType: PropTypes.string.isRequired
};
export default FormikTextField;
